<template>
    <div class="">
        <div class="params mt-5">
            <div class="form-group">
                <label class="form-label">
                    {{ __t("UKLON_LOGO") }}
                </label>
                <fileload :doc_id="this.location.id" doc_type="uklon_logo"></fileload>
            </div>
        </div>
    </div>
</template>

<script>
import Fileload from "../../../../../sys/file_loader/fileload"
export default {
    name: "uklon_logo",
    props: {
        location: {
            type: Object
        }
    },
    components : {
        Fileload
    },

    computed : {

    }
}
</script>

<style scoped>

</style>
